import { render, staticRenderFns } from "./SoftwareComponentTypeEdit.vue?vue&type=template&id=5fb17b54&"
import script from "./SoftwareComponentTypeEdit.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports